import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";

const dateUtils = new DateUtils();

export const FUNCTION_STATUS = {
    assigned: {
        label: "Assigned",
        color: "success",
    },
    not_assigned: {
        label: "Not assigned",
        color: "warning",
    },
};

export const EMPTY_VALUE = "—";

export const formatFunctionDate = (value) => {
    if (value === null || value === undefined || value === "") {
        return EMPTY_VALUE;
    }

    if (typeof value === "number" || (typeof value === "string" && /^\d+$/.test(value))) {
        return (
            dateUtils.convertTimeStampToDate(
                Number(value),
                INTERNATIONAL_DATE_FORMAT
            ) || EMPTY_VALUE
        );
    }

    return dateUtils.convertDateToDate(value, INTERNATIONAL_DATE_FORMAT) || EMPTY_VALUE;
};

export const formatFunctionDescription = (description) => {
    if (!description || !String(description).trim()) {
        return EMPTY_VALUE;
    }

    return description;
};

export const getAssignedUserDisplayName = (user) => {
    if (!user) {
        return "";
    }

    if (user.full_name) {
        return user.full_name;
    }

    return [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
};

export const getAssignedUserInitial = (user) => {
    const name = getAssignedUserDisplayName(user);

    return name ? name[0] : "";
};

export const assignedUserHasRole = (user) => {
    if (!user || typeof user !== "object") {
        return false;
    }

    if (user.role) {
        return true;
    }

    return Array.isArray(user.roles) && user.roles.length > 0;
};

export const shouldShowAssignedRoleColumn = (functions = []) =>
    functions.some((item) =>
        (item.assigned_users || []).some(assignedUserHasRole)
    );

export const formatAssignedUserRole = (user, t) => {
    if (user?.role) {
        return t(user.role);
    }

    if (Array.isArray(user?.roles) && user.roles.length) {
        return user.roles.map((role) => t(role)).join(", ");
    }

    return EMPTY_VALUE;
};

export const sortFunctions = (items, sortField, sortOrder) => {
    if (!sortField || !sortOrder) {
        return items;
    }

    const direction = String(sortOrder).toLowerCase() === "desc" ? -1 : 1;

    return [...items].sort((a, b) => {
        const aVal = (a?.[sortField] ?? "").toString().toLowerCase();
        const bVal = (b?.[sortField] ?? "").toString().toLowerCase();

        if (aVal < bVal) {
            return -1 * direction;
        }

        if (aVal > bVal) {
            return 1 * direction;
        }

        return 0;
    });
};

export const filterFunctions = (items, search) => {
    const query = String(search || "").trim().toLowerCase();

    if (!query) {
        return items;
    }

    return items.filter((item) => {
        const title = String(item?.title || "").toLowerCase();
        const description = String(item?.description || "").toLowerCase();

        return title.includes(query) || description.includes(query);
    });
};
